import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import './index.scss'

class SingleImage extends Component {
  render () {
    const { children, img, caption, alt, margin, small, stacked } = this.props

    let singleImageClass, captionContainer

    if (margin && stacked) {
      singleImageClass = 'inner stacked'
    } else if (margin) {
      singleImageClass = 'inner'
    } else {
      singleImageClass = 'single-image'
    }

    if (small) {
      singleImageClass = 'small-image'
    }
    
    if (caption) {
      captionContainer = (
        <figcaption>
          {caption}
        </figcaption>
      )
    }

    return (
      <figure className={singleImageClass}>
        <img src={img} alt={alt} />
        {captionContainer}
      </figure>

    )
  }
}

SingleImage.propTypes = {
  children: PropTypes.node,
  img: PropTypes.string,
  caption: PropTypes.string,
  alt: PropTypes.string,
  margin: PropTypes.bool,
  stacked: PropTypes.bool,
}

export default SingleImage



// WEBPACK FOOTER //
// ./src/components/SingleImage/index.js